import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MtxColorpickerModule } from '@ng-matero/extensions/colorpicker';

import { SharedModule } from '@blaze-shared/shared-feature';
import {
  CheckboxComponent,
  ColorPickerComponent,
  DialogComponent,
  ScrollerComponent,
  SliderComponent,
  TooltipDirective,
} from '@blaze-shared/shared-ui';
import { StyleStateModule } from '@blaze-shared/style-state-feature';

import { ColorPaletteBarComponent } from './color-palette-bar/color-palette-bar.component';
import { StyleSheetRoleIconComponent } from './style-sheets-panel/style-sheet-role-icon.component';
import { StyleSheetsPanelComponent } from './style-sheets-panel/style-sheets-panel.component';
import { ThemeEditorFormComponent } from './theme-editor-form/theme-editor-form.component';
import { ThemeEditorMenuComponent } from './theme-editor-menu/theme-editor-menu.component';
import { ThemeEditorPanelComponent } from './theme-editor-panel/theme-editor-panel.component';
import { ThemeEditorSaveDialogComponent } from './theme-editor-save-dialog/theme-editor-save-dialog.component';
import { VisualEffectConfigDialogComponent } from './visual-effect-config-dialog/visual-effect-config-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MtxColorpickerModule,
    DragDropModule,
    SliderComponent,
    StyleStateModule,
    ScrollerComponent,
    ColorPickerComponent,
    StyleSheetRoleIconComponent,
    DialogComponent,
    CheckboxComponent,
    TooltipDirective,
  ],
  declarations: [
    ThemeEditorFormComponent,
    ThemeEditorMenuComponent,
    ThemeEditorPanelComponent,
    ColorPaletteBarComponent,
    ThemeEditorSaveDialogComponent,
    VisualEffectConfigDialogComponent,
    StyleSheetsPanelComponent,
  ],
  exports: [ThemeEditorMenuComponent, ColorPaletteBarComponent, StyleSheetRoleIconComponent],
})
export class ThemeEditorModule {}
